export const API_ERROR = "api_failed";
export const SET_PARAMS = "Audit_set_params";

export const AUDIT_PURCHASE_ORDER_LIST = "Audit_purchase_Ordert_List";
export const AUDIT_PURCHASE_ORDER_LIST_SUCCESS =
  "Audit_purchase_Ordert_List_Successful";

export const OPEN_SCREEN = "audit_open_Screen";

export const AUDIT_PURCHASE_ORDER = "Audit_purchase_Ordert";

//--------------
export const AUDIT_PURCHASE_ORDER_ROW_DATA = "audit_purchase_Ordert_row_data";
export const AUDIT_PURCHASE_ORDER_ROW_DATA_SUCCESS =
  "audit_purchase_Ordert_row_data_Successful";

export const AUDIT_IGP_LIST_DATA = "audit_IGP_list_data";
export const AUDIT_IGP_LIST_DATA_SUCCESS = "audit_IGP_list_data_Successful";

export const AUDIT_IGP_ROW_DATA = "audit_IGP_row_data";
export const AUDIT_IGP_ROW_DATA_SUCCESS = "audit_IGP_row_data_Successful";

export const AUDIT_QUOTATION_ROW_DATA = "audit_quotation_row_data";
export const AUDIT_QUOTATION_ROW_DATA_SUCCESS =
  "audit_quotation_row_data_Successful";

export const AUDIT_RFQ_ROW_DATA = "audit_rfq_row_data";
export const AUDIT_RFQ_ROW_DATA_SUCCESS = "audit_rfq_row_data_Successful";


export const AUDIT_CQ_DATA = "audit_cq_data";

export const AUDIT_PI_ROW_DATA = "audit_PI_row_data";
export const AUDIT_PI_ROW_DATA_SUCCESS = "audit_PI_row_data_Successful";

export const AUDIT_MR_ROW_DATA = "audit_MR_row_data";
export const AUDIT_MR_ROW_DATA_SUCCESS = "audit_MR_row_data_Successful";

export const AUDIT_MIN_WINDOW = "audit_min_window";
export const AUDIT_MAX_WINDOW = "audit_max_window";
export const AUDIT_POP_RIGHT = "audit_pop_right";

export const ITEM_AUDIT_APPROVAL = "item_audit_approval";
